import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import MaisonMousseHome from '../maisonmousse/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/maisonmousse/home" element={<MaisonMousseHome />} />
    </Routes>
  );
}

export default Router;
